// Tatar translations
export const tt: Record<string, string> = {
  'menu.dashboard': 'Идарә панеле',
  'menu.customers': 'Клиентлар',
  'menu.products': 'Продуктлар',
  'menu.users': 'Кулланучылар',
  'menu.settings': 'Көйләүләр',
  'menu.logout': 'Чыгу',
  'dashboard.title': 'Идарә панеле',
  'dashboard.newOrder': 'Яңа заказ',
  'order.title': 'Яңа заказ',
  'order.customer': 'Клиент',
  'order.products': 'Продуктлар',
  'order.total': 'Барлыгы',
  'users.title': 'Кулланучылар',
  'users.name': 'Исем',
  'users.email': 'Электрон почта',
  'common.yes': 'Әйе',
  'common.no': 'Юк',
  'common.cancel': 'Баш тарту',
  'common.save': 'Саклау',
  'common.search': 'Эзләү',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Керү',
  'login.welcome': 'Рәхим итегез, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Электрон почта',
  'signup.phone': 'Телефон',
  'menu.reportsAndAccounting': 'Хисаплар һәм бухгалтерия',
  'menu.systemAndCommunication': 'Система һәм элемтә',
};